/* boroj-quiz.js — Boroj fragrance finder. Sequence mirrors bestperfume.store/pages/product-finder EXACTLY:
   intent → fragrance direction (gender) → fragrance reference (mood cards) → feel → occasion → strength.
   No free-text/perfume-name question. Bilingual: Arabic (RTL, default) and English (LTR, exact bestperfume wording),
   chosen by the storefront locale (same getLang logic as the PDP widget). Scores every product against the live
   verified BKPP_DATA (window.BKPPLookup). Perfumes only, one version per perfume, no aged editions.
   Top 30 internally, Top 10 shown with superlative badges + a personalised
   "why this fits you" checklist + "how it differs" + add-to-cart (live variant).
   Persistence/personalization-ready: tunable CONFIG, serializable state, save/load seams, boroj:quiz:complete event.
*/
(function () {
  'use strict';

  var R = window.BorojReco; // shared recommendation engine (assets/boroj-reco-engine.js)

  /* ─────────────────────────── CONFIG ─────────────────────────── */
  var CONFIG = {
    stateVersion: 5, topInternal: 30, topShown: 10, minConfidence: 0.28, displayFloor: 60,
    weights: { direction: 0.30, feel: 0.22, occasion: 0.18, strength: 0.30 },
    genderMod: { same: 0.10, unisex: 0.0, opposite: -0.12 }, giftOppositePenaltyScale: 0.4,
    directionAccords: {
      fresh_bold:  ['fresh', 'citrus', 'aquatic', 'aromatic', 'marine', 'green', 'fresh spicy', 'ozonic'],
      clean_classy:['white musk', 'musky', 'powdery', 'soft floral', 'iris', 'woody', 'clean'],
      light_airy:  ['citrus', 'fresh', 'green', 'floral', 'aquatic', 'tea', 'white floral'],
      sweet_warm:  ['sweet', 'vanilla', 'amber', 'warm spicy', 'caramel', 'gourmand', 'tonka']
    },
    feelAccords: {
      clean:       ['clean', 'white musk', 'fresh', 'soft floral', 'powdery', 'citrus'],
      compliments: ['sweet', 'vanilla', 'amber', 'fruity', 'floral', 'tonka'],
      expensive:   ['oud', 'amber', 'incense', 'woody', 'leather', 'saffron', 'resinous'],
      sexy:        ['amber', 'vanilla', 'musky', 'oud', 'warm spicy', 'leather'],
      standout:    ['oud', 'leather', 'smoky', 'warm spicy', 'tobacco', 'animalic', 'incense']
    },
    occasionSeasons: { everyday: ['day', 'sp', 'su'], work: ['day', 'sp', 'a'], date: ['night', 'a', 'w'], party: ['night', 'su'], special: ['night', 'w'] },
    strengthTarget: { light: { lon: 2, sil: 1 }, moderate: { lon: 3, sil: 3 }, strong: { lon: 4, sil: 4 } }
  };

  /* Questions — EXACT bestperfume sequence + wording (en), with Arabic equivalents. */
  /* SVG line-icon set (Lucide-style, currentColor) — replaces emoji for a premium, consistent look */
  function svg(inner) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="bq-svg">' + inner + '</svg>'; }
  var ICONS = {
    user: svg('<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>'),
    gift: svg('<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/>'),
    sparkles: svg('<path d="M12 3l1.7 4.6L18 9l-4.3 1.4L12 15l-1.7-4.6L6 9l4.3-1.4z"/><path d="M18 13l.8 2.2L21 16l-2.2.8L18 19l-.8-2.2L15 16l2.2-.8z"/>'),
    sprout: svg('<path d="M7 20h10"/><path d="M12 20V10"/><path d="M12 10C12 6 9 5 6 5c0 3 2 5 6 5z"/><path d="M12 10c0-3 2-4 5-4 0 3-2 4-5 4z"/>'),
    mars: svg('<circle cx="10" cy="14" r="6"/><path d="M14.5 9.5 21 3"/><path d="M16 3h5v5"/>'),
    venus: svg('<circle cx="12" cy="8" r="6"/><path d="M12 14v8"/><path d="M9 19h6"/>'),
    venusMars: svg('<circle cx="11" cy="13" r="5"/><path d="M11 18v4"/><path d="M9 20h4"/><path d="m15 9 5-5"/><path d="M16 4h4v4"/>'),
    help: svg('<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 0 1 4.5 1.5c0 1.5-2 2-2 3.5"/><path d="M12 17h.01"/>'),
    waves: svg('<path d="M2 7c2 0 2 2 4 2s2-2 4-2 2 2 4 2 2-2 4-2 2 2 4 2"/><path d="M2 12c2 0 2 2 4 2s2-2 4-2 2 2 4 2 2-2 4-2 2 2 4 2"/><path d="M2 17c2 0 2 2 4 2s2-2 4-2 2 2 4 2 2-2 4-2 2 2 4 2"/>'),
    droplet: svg('<path d="M12 2.7c3 3.5 6 6.8 6 10.3a6 6 0 0 1-12 0c0-3.5 3-6.8 6-10.3z"/>'),
    cloud: svg('<path d="M17.5 19a4.5 4.5 0 0 0 0-9 6 6 0 0 0-11.6-1.5A4 4 0 0 0 6.5 19z"/>'),
    flame: svg('<path d="M12 2c2 4 5 6 5 10a5 5 0 0 1-10 0c0-1.6.6-2.7 1.6-3.7C9 10 10 11 10 12.5 11.6 11 11 7 12 2z"/>'),
    message: svg('<path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>'),
    gem: svg('<path d="M6 3h12l4 6-10 12L2 9z"/><path d="M11 3 8 9l4 12 4-12-3-6"/><path d="M2 9h20"/>'),
    heart: svg('<path d="M19 14c1.4-1.4 3-3.2 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.7 0-3 .5-4.5 2-1.5-1.5-2.8-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.6 4.1 3 5.5l7 7z"/>'),
    star: svg('<polygon points="12 3 14.6 8.6 21 9.3 16.2 13.7 17.5 20 12 16.8 6.5 20 7.8 13.7 3 9.3 9.4 8.6"/>'),
    sun: svg('<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5 19 19M19 5l-1.5 1.5M6.5 17.5 5 19"/>'),
    briefcase: svg('<rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><path d="M2 13h20"/>'),
    wine: svg('<path d="M8 22h8"/><path d="M12 15v7"/><path d="M7 4h10l-.7 5a4.3 4.3 0 0 1-8.6 0z"/>'),
    crown: svg('<path d="M3 8l4 4 5-6 5 6 4-4v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/>'),
    cLight: svg('<circle cx="12" cy="12" r="8"/>'),
    cHalf: svg('<circle cx="12" cy="12" r="8"/><path d="M12 4a8 8 0 0 1 0 16z" fill="currentColor" stroke="none"/>'),
    cFull: svg('<circle cx="12" cy="12" r="8" fill="currentColor" stroke="none"/>')
  };

  var QUESTIONS = [
    { id: 'intent', ar: 'لمن هذا العطر؟', en: 'Who is this perfume for?', options: [
        { v: 'me', ar: 'لنفسي', en: 'For me', icon: ICONS.user }, { v: 'gift', ar: 'هدية', en: 'For a gift', icon: ICONS.gift },
        { v: 'known', ar: 'أعرف ما أحب', en: 'I know what I like', icon: ICONS.sparkles }, { v: 'new', ar: 'جديد تمامًا', en: 'Totally new', icon: ICONS.sprout } ] },
    { id: 'gender', ar: 'ما توجّه العطر الذي تفضّله؟', en: 'Which fragrance direction do you prefer?', options: [
        { v: 'men', ar: 'رجالي', en: 'Men', icon: ICONS.mars }, { v: 'women', ar: 'نسائي', en: 'Women', icon: ICONS.venus },
        { v: 'unisex', ar: 'للجنسين', en: 'Unisex', icon: ICONS.venusMars }, { v: 'any', ar: 'غير متأكد', en: 'Not sure', icon: ICONS.help } ] },
    { id: 'direction', ar: 'اختر عطرًا مرجعيًا يعجبك:', en: 'Select a fragrance reference that you enjoy:', options: [
        { v: 'fresh_bold', ar: 'منعش وجريء', en: 'Fresh & Bold', icon: ICONS.waves }, { v: 'clean_classy', ar: 'نظيف وأنيق', en: 'Clean & Classy', icon: ICONS.droplet },
        { v: 'light_airy', ar: 'خفيف وهادئ', en: 'Light & Airy', icon: ICONS.cloud }, { v: 'sweet_warm', ar: 'حلو ودافئ', en: 'Sweet & Warm', icon: ICONS.flame },
        { v: 'na', ar: 'غير متأكد', en: 'Not Sure', icon: ICONS.help } ] },
    { id: 'feel', ar: 'كيف تريد أن تشعر به؟', en: 'How do you want your scent to feel?', options: [
        { v: 'clean', ar: 'نظيف', en: 'Clean', icon: ICONS.droplet }, { v: 'compliments', ar: 'يجذب المديح', en: 'Compliments', icon: ICONS.message },
        { v: 'expensive', ar: 'فخم', en: 'Expensive', icon: ICONS.gem }, { v: 'sexy', ar: 'جذّاب', en: 'Sexy', icon: ICONS.heart },
        { v: 'standout', ar: 'لافت', en: 'Stand out', icon: ICONS.star } ] },
    { id: 'occasion', ar: 'أين ستستخدمه غالبًا؟', en: 'Where will you wear this perfume most?', options: [
        { v: 'everyday', ar: 'يومي', en: 'Everyday', icon: ICONS.sun }, { v: 'work', ar: 'العمل / الدراسة', en: 'Work / School', icon: ICONS.briefcase },
        { v: 'date', ar: 'موعد', en: 'Date night', icon: ICONS.wine }, { v: 'party', ar: 'حفلة', en: 'Party / Club', icon: ICONS.sparkles },
        { v: 'special', ar: 'مناسبة خاصة', en: 'Special occasion', icon: ICONS.crown } ] },
    { id: 'strength', ar: 'ما قوة العطر التي تناسبك؟', en: 'Which fragrance strength fits you?', options: [
        { v: 'light', ar: 'خفيف', en: 'Light', icon: ICONS.cLight }, { v: 'moderate', ar: 'متوسط', en: 'Moderate', icon: ICONS.cHalf },
        { v: 'strong', ar: 'قوي', en: 'Strong', icon: ICONS.cFull }, { v: 'na', ar: 'غير متأكد', en: 'Not sure', icon: ICONS.help } ] }
  ];

  var COPY = {
    ar: {
      dir: 'rtl',
      intro: { title: 'اعثر على عطرك في ٣٠ ثانية', sub: 'لا مزيد من التخمين. أجب عن أسئلة قصيرة ودعنا نرشّح لك أقرب العطور إلى ذوقك.', cta: 'ابدأ الآن', note: '٦ أسئلة قصيرة · أقل من دقيقة' },
      next: 'التالي', back: 'رجوع', loading: 'نُحضّر توصياتك…',
      resultsTitle: 'عطورك المختارة', resultsSub: 'مجموعة منسّقة بناءً على إجاباتك',
      whyH: 'لماذا يناسبك:', diffH: 'ما يميّزه:', inspired: 'مستوحى من', match: 'تطابق', pctMark: '٪',
      addToCart: 'أضف للسلة', view: 'اكتشف العطر', restart: 'إعادة الاختبار', fail: 'تعذّر تحميل الاختبار. يرجى تحديث الصفحة.',
      genderPath: { men: 'الرجالي', women: 'النسائي', unisex: 'للجنسين', any: '' },
      occasionL: { everyday: 'الاستخدام اليومي', work: 'العمل والدراسة', date: 'المواعيد', party: 'الحفلات', special: 'المناسبات الخاصة' },
      strengthL: { light: 'ثبات خفيف وقريب', moderate: 'ثبات متوازن', strong: 'ثبات قوي وفوّاح', na: '' },
      feelL: { clean: 'نظيف ومنعش', compliments: 'يجذب المديح', expensive: 'فخم وراقٍ', sexy: 'جذّاب', standout: 'لافت ومميّز' },
      whyGender: function (g) { return 'يطابق توجّهك ' + g; },
      whyFeel: function (f) { return 'مصمّم لإحساس ' + f; },
      whyOcc: function (o) { return 'مثالي لـ ' + o; },
      whyNotes: function (n) { return 'نوتات مميّزة: ' + n; },
      diffAnchor: function (x) { return 'يبرز بحضور ' + x + ' يمنحه طابعًا خاصًا.'; },
      badges: ['الأفضل لك', 'الأكثر جذبًا للإعجاب', 'الأجرأ والأكثر تميّزًا', 'الأطول ثباتًا', 'الخيار الأنعم', 'خيار آمن ومضمون', 'بديل مميّز', 'خيار متنوّع', 'قيمة رائعة', 'يستحق التجربة']
    },
    en: {
      dir: 'ltr',
      intro: { title: 'Find your perfume in 30 seconds.', sub: 'No more guessing. Get your matches.', cta: 'Get started', note: '6 quick questions · under a minute' },
      next: 'Next', back: 'Back', loading: 'Curating your matches…',
      resultsTitle: 'Your fragrance matches', resultsSub: 'Here is your curated selection based on your answers.',
      whyH: 'Why this fits you:', diffH: 'How it differs:', inspired: 'resembling', match: 'Match', pctMark: '%',
      addToCart: 'Add to Cart', view: 'View Product', restart: 'Retake quiz', fail: 'Could not load the quiz. Please refresh.',
      genderPath: { men: 'MEN', women: 'WOMEN', unisex: 'UNISEX', any: '' },
      occasionL: { everyday: 'everyday wear', work: 'work & school', date: 'date nights', party: 'parties & clubs', special: 'special occasions' },
      strengthL: { light: 'light, close-to-skin projection', moderate: 'a balanced strength', strong: 'strong, long-lasting projection', na: '' },
      feelL: { clean: 'clean', compliments: 'compliments', expensive: 'expensive', sexy: 'sexy', standout: 'stand-out' },
      whyGender: function (g) { return 'Strictly matches your preferred ' + g + ' scent path'; },
      whyFeel: function (f) { return "Optimized for a refined '" + f + "' vibe"; },
      whyOcc: function (o) { return 'Ideal for ' + o; },
      whyNotes: function (n) { return 'Features premium notes: ' + n; },
      diffAnchor: function (x) { return 'Highlights ' + x + ' for a distinctive character.'; },
      badges: ['BEST OVERALL', 'MOST COMPLIMENT-FRIENDLY', 'BOLDEST PICK', 'LONGEST LASTING', 'SOFTER ALTERNATIVE', 'SAFEST BLIND BUY', 'GREAT ALTERNATIVE', 'VERSATILE PICK', 'GREAT VALUE', 'WORTH A TRY']
    }
  };

  /* ─────────────────────────── helpers ─────────────────────────── */
  function getLang() {
    var l = (document.documentElement.lang || '').toLowerCase();
    if (l && l !== 'ar') return 'en';
    if (/^\/(en|english)(\/|$)/i.test(window.location.pathname)) return 'en';
    return 'ar';
  }
  function low(s) { return (s || '').toString().toLowerCase().trim(); }
  function titleCase(s) { return (s || '').replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }
  function uniqLow(a) { var o = [], s = {}; (a || []).forEach(function (x) { var k = low(x); if (k && !s[k]) { s[k] = 1; o.push(k); } }); return o; }
  function intersect(a, b) { var sb = {}; b.forEach(function (x) { sb[x] = 1; }); return a.filter(function (x) { return sb[x]; }); }
  function clamp01(x) { return x < 0 ? 0 : (x > 1 ? 1 : x); }
  function esc(s) { return (s || '').toString().replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function genderEnToKey(g) { g = low(g); return g === 'men' ? 'men' : (g === 'women' ? 'women' : 'unisex'); }

  function accordsOf(c) { if (c.profile && c.profile.accords && c.profile.accords.length) return uniqLow(c.profile.accords.map(function (a) { return a.n_en; })); return uniqLow(c.a || []); }
  function notesOf(c) { if (!c.profile) return []; var o = []; ['top', 'mid', 'base'].forEach(function (t) { (c.profile[t] || []).forEach(function (n) { o.push(n.n_en); }); }); return uniqLow(o); }
  function accordsArOf(c) { if (c.profile && c.profile.accords && c.profile.accords.length) return c.profile.accords.map(function (a) { return a.n || a.n_en; }); return (c.a || []); }
  function accMapAr(c) { var m = {}; if (c.profile && c.profile.accords) c.profile.accords.forEach(function (a) { if (a.n_en) m[low(a.n_en)] = a.n || a.n_en; }); return m; }
  function genderOf(c) { if (c.profile && c.profile.gender_en) return genderEnToKey(c.profile.gender_en); return genderEnToKey(c.g); }
  /* accords for DISPLAY in the active language */
  function accordsDisp(c, lang) { return lang === 'en' ? accordsOf(c).map(titleCase) : accordsArOf(c); }

  /* ─────────────────────────── scoring ─────────────────────────── */
  /* Scoring components (accordKeywordMatch, seasonMatch, strengthMatch, genderMod, confidenceOf)
     now live in the shared engine assets/boroj-reco-engine.js (R.*) — see scoreCandidate below. */
  // Scoring delegates to the shared engine (assets/boroj-reco-engine.js): the answer→component
  // mapping stays here; the math lives in the engine so Quiz + cart tester-upsell share one core.
  // This composition is regression-locked identical to the old inline formula (out/quiz-regression.test.js).
  function scoreCandidate(c, ans) {
    var dir = ans.direction && ans.direction !== 'na' ? CONFIG.directionAccords[ans.direction] : null;
    var feel = ans.feel && ans.feel !== 'na' ? CONFIG.feelAccords[ans.feel] : null;
    var comps = [
      { w: CONFIG.weights.direction, v: R.accordKeywordMatch(c, dir) },
      { w: CONFIG.weights.feel, v: R.accordKeywordMatch(c, feel) },
      { w: CONFIG.weights.occasion, v: R.seasonMatch(c, (ans.occasion && ans.occasion !== 'na') ? CONFIG.occasionSeasons[ans.occasion] : null) },
      { w: CONFIG.weights.strength, v: R.strengthMatch(c, (ans.strength && ans.strength !== 'na') ? CONFIG.strengthTarget[ans.strength] : null) }
    ];
    var add = [R.genderMod(c, ans.gender, { unisex: CONFIG.genderMod.unisex, same: CONFIG.genderMod.same, opposite: CONFIG.genderMod.opposite, giftScale: CONFIG.giftOppositePenaltyScale, intentGift: ans.intent === 'gift' })];
    return { raw: R.blend(comps, add), confidence: R.confidenceOf(c) };
  }
  function displayPct(raw) { return Math.round(CONFIG.displayFloor + (99 - CONFIG.displayFloor) * raw); }
  function assignBadge(item, rank, used, T) {
    if (rank === 0) { used[T.badges[0]] = 1; return T.badges[0]; }
    var c = item.c, acc = accordsOf(c), lon = c.profile && c.profile.lon, cand = [];
    if (intersect(['sweet', 'vanilla', 'amber', 'fruity'], acc).length >= 2) cand.push(T.badges[1]);
    if (intersect(['oud', 'leather', 'smoky', 'incense'], acc).length >= 1) cand.push(T.badges[2]);
    if (typeof lon === 'number' && lon >= 4) cand.push(T.badges[3]);
    if (typeof lon === 'number' && lon <= 2) cand.push(T.badges[4]);
    if (item.confidence >= 0.8) cand.push(T.badges[5]);
    cand = cand.concat(T.badges.slice(1));   // ensure a distinct badge is always available
    for (var i = 0; i < cand.length; i++) if (!used[cand[i]]) { used[cand[i]] = 1; return cand[i]; }
    return T.badges[T.badges.length - 1];
  }

  /* ─────────────────────────── state ─────────────────────────── */
  var STORE_KEY = 'boroj_quiz_state_v' + CONFIG.stateVersion;
  function saveState(s) { try { localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {} }
  function loadState() { try { var s = localStorage.getItem(STORE_KEY); return s ? JSON.parse(s) : null; } catch (e) { return null; } }

  /* ─────────────────────────── engine ─────────────────────────── */
  function Quiz(root) {
    this.root = root; this.lang = getLang(); this.T = COPY[this.lang];
    this.products = []; this.candidates = []; this.step = 0;
    this.answers = { intent: null, gender: null, direction: null, feel: null, occasion: null, strength: null };
    this.ranked = [];
  }
  Quiz.prototype.el = function (s) { return this.root.querySelector(s); };
  Quiz.prototype.qText = function (q) { return this.lang === 'en' ? q.en : q.ar; };
  Quiz.prototype.oText = function (o) { return this.lang === 'en' ? o.en : o.ar; };

  Quiz.prototype.init = function () {
    var self = this;
    this.root.setAttribute('dir', this.T.dir);
    this.root.classList.toggle('bq-en', this.lang === 'en');
    var intro = this.el('.bq-intro'); var T = this.T;
    intro.innerHTML = '<h1 class="bq-intro-title">' + esc(T.intro.title) + '</h1>'
      + '<p class="bq-intro-sub">' + esc(T.intro.sub) + '</p>'
      + '<button type="button" class="bq-btn bq-btn--primary bq-btn--lg bq-start-btn">' + esc(T.intro.cta) + '</button>'
      + '<p class="bq-intro-note">' + esc(T.intro.note) + '</p>';
    intro.querySelector('.bq-start-btn').addEventListener('click', function () { intro.hidden = true; self.el('.bq-stage').hidden = false; self.load(); });
  };
  Quiz.prototype.load = function () {
    var self = this;
    fetch(this.root.getAttribute('data-products'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { self.products = d || []; self.buildCandidates(); self.renderStep(); })
      .catch(function () { self.fail(); });
  };
  Quiz.prototype.buildCandidates = function () {
    var lk = window.BKPPLookup;
    // Results are PERFUMES ONLY, ONE version per perfume, and never an aged (تعتيق) edition.
    var seen = {};
    function isAged(p) { return /-aged$/.test(p.h || '') || (p.t || '').indexOf('تعتيق') !== -1; }
    function origKey(p) {
      var k = (p.on || p.t || p.h || '').toLowerCase();
      return k.replace(/["'‘’“”]/g, '').replace(/\s+by\s+|\s+-\s+/g, ' ').replace(/\s+/g, ' ').trim();
    }
    this.candidates = [];
    for (var i = 0; i < this.products.length; i++) {
      var p = this.products[i];
      if (isAged(p)) continue;                 // skip aged (تعتيق) editions
      if (!(p.on || p.f || p.a)) continue;     // perfumes only — must carry a fragrance identity
      var key = origKey(p);
      if (seen[key]) continue;                 // one version per perfume (dedupe by original)
      seen[key] = 1;
      var c = { h: p.h, t: p.t, u: p.u, on: p.on, g: p.g, f: p.f, a: p.a, profile: null };
      if (lk) c.profile = lk(p.on || '', p.h) || null;
      this.candidates.push(c);
    }
  };
  Quiz.prototype.rank = function () {
    var self = this;
    var scored = this.candidates.map(function (c) { var s = scoreCandidate(c, self.answers); return { c: c, raw: s.raw, confidence: s.confidence, pct: displayPct(s.raw) }; });
    scored.sort(function (a, b) { return b.raw !== a.raw ? b.raw - a.raw : b.confidence - a.confidence; });
    var rk = R.rank(scored, { topInternal: CONFIG.topInternal, minConfidence: CONFIG.minConfidence, topShown: CONFIG.topShown });
    this.ranked = rk.ranked;
    return rk.shown;
  };

  /* ── wizard ── */
  Quiz.prototype.crumbs = function () {
    var self = this, out = [];
    QUESTIONS.forEach(function (q, i) {
      if (i >= self.step) return;
      var v = self.answers[q.id]; if (!v) return;
      var opt = q.options.filter(function (o) { return o.v === v; })[0]; if (!opt) return;
      out.push('<span class="bq-crumb"><span aria-hidden="true">' + opt.icon + '</span> ' + esc(self.oText(opt)) + '</span>');
    });
    return out.length ? '<div class="bq-crumbs">' + out.join('') + '</div>' : '';
  };
  Quiz.prototype.renderStep = function () {
    var self = this, q = QUESTIONS[this.step], total = QUESTIONS.length, pct = Math.round((this.step / total) * 100), T = this.T;
    var stage = this.el('.bq-stage'), html = '';
    html += '<div class="bq-bar"><div class="bq-bar-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><div class="bq-bar-fill" style="width:' + pct + '%"></div></div><span class="bq-bar-pct">' + pct + (this.lang === 'en' ? '%' : '٪') + '</span></div>';
    html += this.crumbs();
    html += '<h2 class="bq-q-title">' + esc(this.qText(q)) + '</h2>';
    html += '<div class="bq-options" role="group" aria-label="' + esc(this.qText(q)) + '">';
    var cur = this.answers[q.id];
    q.options.forEach(function (o) {
      var on = cur === o.v;
      html += '<button type="button" class="bq-opt' + (on ? ' bq-opt--on' : '') + '" data-v="' + esc(o.v) + '" aria-pressed="' + on + '">'
        + '<span class="bq-opt-ico" aria-hidden="true">' + o.icon + '</span><span class="bq-opt-lbl">' + esc(self.oText(o)) + '</span></button>';
    });
    html += '</div><div class="bq-nav">';
    if (this.step > 0) html += '<button type="button" class="bq-btn bq-back">' + esc(T.back) + '</button>';
    html += '</div>';
    stage.innerHTML = html;
    stage.querySelectorAll('.bq-opt').forEach(function (btn) {
      btn.addEventListener('click', function () { self.answers[q.id] = btn.getAttribute('data-v'); self.advance(); });
    });
    var back = stage.querySelector('.bq-back'); if (back) back.addEventListener('click', function () { if (self.step > 0) { self.step--; self.renderStep(); } });
    var f = stage.querySelector('.bq-opt'); if (f) f.focus();
  };
  Quiz.prototype.advance = function () { if (this.step < QUESTIONS.length - 1) { this.step++; this.renderStep(); } else { this.finish(); } };

  /* ── results ── */
  Quiz.prototype.whyFits = function (c) {
    var a = this.answers, T = this.T, out = [];
    if (a.gender && a.gender !== 'any' && T.genderPath[a.gender]) out.push(T.whyGender(T.genderPath[a.gender]));
    if (a.feel && a.feel !== 'na' && T.feelL[a.feel]) out.push(T.whyFeel(T.feelL[a.feel]));
    if (a.occasion && a.occasion !== 'na' && T.occasionL[a.occasion]) out.push(T.whyOcc(T.occasionL[a.occasion]));
    if (a.strength && a.strength !== 'na' && T.strengthL[a.strength]) out.push(T.strengthL[a.strength]);
    var disp = accordsDisp(c, this.lang); if (disp.length) out.push(T.whyNotes(disp.slice(0, 3).join(this.lang === 'en' ? ', ' : '، ')));
    return out.slice(0, 4);
  };
  Quiz.prototype.howDiffers = function (c) {
    var disp = accordsDisp(c, this.lang);
    return disp.length ? this.T.diffAnchor(disp.slice(0, 2).join(this.lang === 'en' ? ' and ' : ' و')) : '';
  };
  Quiz.prototype.finish = function () {
    var self = this, stage = this.el('.bq-stage'), T = this.T;
    stage.innerHTML = '<div class="bq-loading">' + esc(T.loading) + '</div>';
    var shown = this.rank();
    var state = { version: CONFIG.stateVersion, lang: this.lang, answers: this.answers, ranked: this.ranked.map(function (x) { return { h: x.c.h, raw: x.raw, pct: x.pct, confidence: x.confidence }; }), shown: shown.map(function (x) { return x.c.h; }), ts: Date.now() };
    saveState(state);
    document.dispatchEvent(new CustomEvent('boroj:quiz:complete', { detail: state, bubbles: true }));
    Promise.all(shown.map(function (x) {
      return fetch(x.c.u + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return { x: x, live: p }; }).catch(function () { return { x: x, live: null }; });
    })).then(function (rows) { self.renderResults(rows); });
  };
  /* recommend a 50–100ml size, never a tester / sub-50ml (per merchant rule) */
  function firstAvailableVariant(live) {
    if (!live || !live.variants || !live.variants.length) return null;
    function isTester(v) { var t = (v.title || '') + ''; return /تستر|tester|sample|عينة/i.test(t) || /(^|[^0-9])(5|10|15|20|25|30|35)\s*(مل|ml)/i.test(t); }
    var avail = live.variants.filter(function (v) { return v.available; });
    var pool = avail.length ? avail : live.variants;
    var ok = pool.filter(function (v) { return !isTester(v); });
    if (!ok.length) ok = pool;
    var std = ok.filter(function (v) { return /(^|[^0-9])(50|55|60)([^0-9]|$)/.test((v.title || '') + ''); });
    return std[0] || ok[0] || pool[0] || null;
  }
  Quiz.prototype.money = function (c) { if (typeof c !== 'number') return ''; var v = (Math.round(c) / 100).toLocaleString('en-US'); return this.lang === 'en' ? ('EGP ' + v) : (v + ' ج.م'); };

  Quiz.prototype.renderResults = function (rows) {
    var self = this, stage = this.el('.bq-stage'), T = this.T, used = {};
    var head = '<div class="bq-results-head"><h2 class="bq-q-title bq-results-title">' + esc(T.resultsTitle) + '</h2><p class="bq-q-sub">' + esc(T.resultsSub) + '</p></div>';
    var cards = rows.map(function (row, rank) {
      var c = row.x.c, live = row.live, prof = c.profile;
      var badge = assignBadge(row.x, rank, used, T);
      var img = (live && live.featured_image) || (live && live.images && live.images[0]) || '';
      var variant = firstAvailableVariant(live), price = variant ? self.money(variant.price) : '';
      var inspired = prof ? (prof.inspired || '') : '';
      var why = self.whyFits(c), diff = self.howDiffers(c);
      var chipHtml = accordsDisp(c, self.lang).slice(0, 4).map(function (x) { return '<span class="bq-chip">' + esc(x) + '</span>'; }).join('');
      var matchTxt = self.lang === 'en' ? (row.x.pct + '% ' + T.match) : (T.match + ' ' + row.x.pct + T.pctMark);
      return '<article class="bq-card" data-confidence="' + row.x.confidence.toFixed(2) + '">'
        + '<a class="bq-card-media" href="' + esc(c.u) + '">'
        + (img ? '<img src="' + esc(img) + '" alt="' + esc(c.t) + '" loading="lazy">' : '<span class="bq-card-noimg" aria-hidden="true">' + (self.lang === 'en' ? 'Perfume' : 'عطر') + '</span>')
        + '<span class="bq-badge">' + esc(badge) + '</span></a>'
        + '<div class="bq-card-body">'
        + '<div class="bq-match">' + esc(matchTxt) + '</div>'
        + '<h3 class="bq-card-title"><a href="' + esc(c.u) + '">' + esc(c.t) + '</a></h3>'
        + (inspired ? '<div class="bq-card-insp">' + esc(T.inspired) + ' <strong>' + esc(inspired) + '</strong></div>' : '')
        + (chipHtml ? '<div class="bq-chips">' + chipHtml + '</div>' : '')
        + (why.length ? '<div class="bq-why"><div class="bq-why-h">' + esc(T.whyH) + '</div><ul>' + why.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul></div>' : '')
        + (diff ? '<div class="bq-diff"><strong>' + esc(T.diffH) + '</strong> ' + esc(diff) + '</div>' : '')
        + (price ? '<div class="bq-price">' + esc(price) + '</div>' : '')
        + '<div class="bq-card-actions">'
        + (variant ? '<button type="button" class="bq-btn bq-btn--primary bq-add" data-vid="' + variant.id + '">' + esc(T.addToCart) + (price ? ' — ' + esc(price) : '') + '</button>' : '')
        + '<a class="bq-btn bq-view" href="' + esc(c.u) + '">' + esc(T.view) + '</a>'
        + '</div></div></article>';
    }).join('');
    stage.innerHTML = head + '<div class="bq-results">' + cards + '</div><div class="bq-results-foot"><button type="button" class="bq-btn bq-restart">' + esc(T.restart) + '</button></div>';
    stage.querySelectorAll('.bq-add').forEach(function (btn) { btn.addEventListener('click', function () { self.addToCart(btn); }); });
    var restart = stage.querySelector('.bq-restart');
    if (restart) restart.addEventListener('click', function () { self.step = 0; self.answers = { intent: null, gender: null, direction: null, feel: null, occasion: null, strength: null }; self.renderStep(); self.root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    var liveEl = this.el('.bq-live'); if (liveEl) liveEl.textContent = (this.lang === 'en' ? (rows.length + ' matches shown.') : ('تم عرض ' + rows.length + ' توصيات.'));
  };
  Quiz.prototype.addToCart = function (btn) {
    var vid = btn.getAttribute('data-vid'); if (!vid) return;
    btn.disabled = true; var old = btn.innerHTML; btn.textContent = this.lang === 'en' ? 'Adding…' : 'جارٍ الإضافة…';
    var self = this;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }) })
      .then(function (r) { return r.json(); }).then(function () {
        btn.textContent = self.lang === 'en' ? 'Added ✓' : 'أُضيف ✓';
        if (window.BorojCart && window.BorojCart.added) window.BorojCart.added();
        setTimeout(function () { btn.disabled = false; btn.innerHTML = old; }, 1800);
      }).catch(function () { btn.disabled = false; btn.innerHTML = old; });
  };
  Quiz.prototype.fail = function () { var s = this.el('.bq-stage'); if (s) s.innerHTML = '<div class="bq-loading">' + esc(this.T.fail) + '</div>'; };

  /* node-only export for unit testing */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { CONFIG: CONFIG, QUESTIONS: QUESTIONS, COPY: COPY, scoreCandidate: scoreCandidate, displayPct: displayPct, assignBadge: assignBadge, intersect: intersect, accordsOf: accordsOf, accordsArOf: accordsArOf, genderOf: genderOf };
  }

  /* ─────────────────────────── boot ─────────────────────────── */
  function start() { var root = document.getElementById('boroj-quiz'); if (!root) return; new Quiz(root).init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
